import type { FinancialTransaction } from "@/types";

export const financialSummary = {
  walletBalance: 12480.75,
  pendingWallet: 1250,
  cashDebt: 384,
  settledThisMonth: 38620,
};

export const financialTransactions: FinancialTransaction[] = [
  {
    id: "TX-9021",
    date: "٢٠ سبتمبر ٢٠٢٦",
    label: "مبيعات فرع العليا",
    type: "sale",
    method: "card",
    amount: 3820.5,
    status: "completed",
  },
  {
    id: "TX-9020",
    date: "٢٠ سبتمبر ٢٠٢٦",
    label: "مبيعات فرع النخيل",
    type: "sale",
    method: "applepay",
    amount: 2740,
    status: "completed",
  },
  {
    id: "TX-9019",
    date: "١٩ سبتمبر ٢٠٢٦",
    label: "تسوية إلى الحساب البنكي",
    type: "settlement",
    method: "card",
    amount: -8600,
    status: "completed",
  },
  {
    id: "TX-9017",
    date: "١٨ سبتمبر ٢٠٢٦",
    label: "استرجاع طلب #1032",
    type: "refund",
    method: "wallet",
    amount: -128,
    status: "completed",
  },
  {
    id: "TX-9016",
    date: "١٨ سبتمبر ٢٠٢٦",
    label: "مبيعات فرع الملقا",
    type: "sale",
    method: "wallet",
    amount: 1180,
    status: "completed",
  },
  {
    id: "TX-9014",
    date: "١٧ سبتمبر ٢٠٢٦",
    label: "تسوية إلى الحساب البنكي",
    type: "settlement",
    method: "card",
    amount: -7200,
    status: "completed",
  },
];